import { Columns } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Arrange, Box, Typography, Button } from "@aviary";
import { emersonRoutes } from "@clinic/emerson/data/emersonRoutes";
import patientResourcesImage from "@emerson/assets/images/homepage/patient_resources.png";
import protocolsImage from "@emerson/assets/images/homepage/protocols.png";
import { l } from "@emerson/locales/i18n";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./EducationalResources.styles";

const EducationalResources = () => {
  const { t } = useTranslation();

  const { tablet } = useBreakpoints();

  return (
    <div>
      <Columns customCss={styles.centered}>
        <Columns.Column columnWidth={4}>
          <Arrange isFullHeight justify="center" isVertical>
            <Typography type="h3" css={!!tablet.greaterThan && styles.rightMarginContext}>
              {t(l.educationalResources.Title)}
            </Typography>
            <Typography type="body" css={!!tablet.greaterThan && styles.rightMarginContext}>
              {t(l.educationalResources.Content)}
            </Typography>
          </Arrange>
        </Columns.Column>
        <Columns.Column columnWidth={4}>
          <Box accentColor="sand" padding="medium" css={styles.fullHeightBox}>
            <Arrange isFullWidth isVertical>
              <img css={styles.fullWidthImage} src={protocolsImage} alt="Protocols Image" />
              <Typography type="h3">{t(l.educationalResources.Protocols)}</Typography>
              <Typography type="body">{t(l.educationalResources.ProtocolsContent)}</Typography>
              <Arrange justify="center">
                <Button isColor="system" to={emersonRoutes.external.education.protocols}>
                  {t(l.educationalResources.LearnMore)}
                </Button>
              </Arrange>
            </Arrange>
          </Box>
        </Columns.Column>
        <Columns.Column columnWidth={4}>
          <Box accentColor="sand" padding="medium" css={styles.fullHeightBox}>
            <Arrange isFullWidth isVertical>
              <img
                css={styles.fullWidthImage}
                src={patientResourcesImage}
                alt="Patient Resources Image"
              />
              <Typography type="h3">{t(l.educationalResources.PatientResources)}</Typography>
              <Typography type="body">
                {t(l.educationalResources.PatientResourcesContent)}
              </Typography>
              <Arrange justify="center">
                <Button isColor="system" to={emersonRoutes.external.education.resources}>
                  {t(l.educationalResources.LearnMore)}
                </Button>
              </Arrange>
            </Arrange>
          </Box>
        </Columns.Column>
      </Columns>
    </div>
  );
};

export { EducationalResources };
